export const MAX_FAVORITE_SOURCE_LANGUAGES = 20;

export function normalizeFavoriteSourceLanguages(codes: readonly unknown[] | null | undefined): string[] {
    if (!codes?.length) return [];

    const seen = new Set<string>();
    const normalized: string[] = [];
    for (const code of codes) {
        const value = typeof code === "string" ? code.trim() : "";
        if (!value || seen.has(value)) continue;
        seen.add(value);
        normalized.push(value);
    }
    return normalized;
}

export function resolveFavoriteSourceLanguages(input: {
    activeWorkspaceId: string | null;
    workspaceCodes?: readonly unknown[] | null;
    personalCodes?: readonly unknown[] | null;
    personalLegacyCode?: unknown;
}): string[] {
    if (input.activeWorkspaceId !== null) {
        return normalizeFavoriteSourceLanguages(input.workspaceCodes);
    }

    const personalCodes = normalizeFavoriteSourceLanguages(input.personalCodes);
    if (personalCodes.length > 0) return personalCodes;
    return normalizeFavoriteSourceLanguages([input.personalLegacyCode]);
}
